import React from 'react';
import moment from 'moment';
import { DatePicker } from 'antd';
const { RangePicker } = DatePicker;
function range(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

function disabledDate(current) {
  return current && current.valueOf() > moment().add(-1, 'days');
}

class DatePickerRang extends React.Component {
  render() {
    return (
      <div>
        <RangePicker
          disabledDate={disabledDate}
          // disabledTime={disabledRangeTime}
          showTime={{
            hideDisabledOptions: true,
            defaultValue: [moment('YYYY-MM-DD'), moment('YYYY-MM-DD')]
          }}
          allowClear={false}
          onOk={this.props.onOk}
          format="YYYY-MM-DD"
        />
      </div>
    );
  }
}
export default DatePickerRang;



// WEBPACK FOOTER //
// ./src/components/DatePicker_Rang.js